import { RequiredError } from './base.mjs';

const DUMMY_BASE_URL = "https://example.com";
const assertParamExists = function(functionName, paramName, paramValue) {
  if (paramValue === null || paramValue === void 0) {
    throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
  }
};
const setSearchParams = function(url, ...objects) {
  const searchParams = new URLSearchParams(url.search);
  for (const object of objects) {
    for (const key in object) {
      if (Array.isArray(object[key])) {
        searchParams.delete(key);
        for (const item of object[key]) {
          searchParams.append(key, item);
        }
      } else {
        searchParams.set(key, object[key]);
      }
    }
  }
  url.search = searchParams.toString();
};
const toPathString = function(url) {
  return url.pathname + url.search + url.hash;
};
const createRequestFunction = function(axiosArgs, globalAxios, BASE_PATH, _configuration) {
  return (axios = globalAxios, _basePath = BASE_PATH) => {
    const axiosRequestArgs = {
      /**
       * axios.defaults.baseURL이 있어도 얘가 매번 덮어쓰는 게 불편해서
       * OpenAPI Specification의 basePath는 지원하지 않는다
       */
      // baseURL: configuration?.basePath || basePath,
      ...axiosArgs
    };
    return axios.request(axiosRequestArgs);
  };
};

export { DUMMY_BASE_URL, assertParamExists, createRequestFunction, setSearchParams, toPathString };
//# sourceMappingURL=common.mjs.map
